import { render, staticRenderFns } from "./activateAccount.vue?vue&type=template&id=5321768a&scoped=true&"
import script from "./activateAccount.vue?vue&type=script&lang=js&"
export * from "./activateAccount.vue?vue&type=script&lang=js&"
import style0 from "./activateAccount.vue?vue&type=style&index=0&id=5321768a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5321768a",
  null
  
)

export default component.exports